/**
 * Unified scroll hide/restore for floating UI.
 * Opt-in: add class="scroll-behavior" on any element.
 * Optional: data-scroll-idle-ms (default 2000)
 * Optional: class "scroll-behavior--paused" to skip restore (e.g. while a popup is open)
 */
(function () {
  var SELECTOR = ".scroll-behavior";
  var HIDDEN_CLASS = "scroll-behavior--hidden";
  var PAUSED_CLASS = "scroll-behavior--paused";
  var DEFAULT_IDLE_MS = 2000;

  function getTargets() {
    return document.querySelectorAll(SELECTOR);
  }

  function getIdleMs(targets) {
    var idleMs = DEFAULT_IDLE_MS;
    for (var i = 0; i < targets.length; i++) {
      var value = Number(targets[i].dataset.scrollIdleMs);
      if (value > 0) {
        idleMs = value;
        break;
      }
    }
    return idleMs;
  }

  function initScrollBehavior() {
    if (window.__scrollBehaviorInited) return;
    window.__scrollBehaviorInited = true;

    var lastScrollY = window.scrollY;
    var scrollIdleTimer = null;

    var onScroll = function () {
      var targets = getTargets();
      if (!targets.length) return;

      var currentY = window.scrollY;
      if (Math.abs(currentY - lastScrollY) > 5) {
        for (var i = 0; i < targets.length; i++) {
          targets[i].classList.add(HIDDEN_CLASS);
        }
      }
      lastScrollY = currentY;

      clearTimeout(scrollIdleTimer);
      var idleMs = getIdleMs(targets);
      scrollIdleTimer = setTimeout(function () {
        var els = getTargets();
        for (var j = 0; j < els.length; j++) {
          if (els[j].classList.contains(PAUSED_CLASS)) continue;
          if (els[j].dataset.scrollRestore === "false") continue;
          els[j].classList.remove(HIDDEN_CLASS);
        }
      }, idleMs);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
  }

  window.initScrollBehavior = initScrollBehavior;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initScrollBehavior);
  } else {
    initScrollBehavior();
  }
})();
